import { Comment } from '../../declarations/comment.interface';

export interface CommentState {
  editingComment: Comment;
}

export const initialState: CommentState = {
  editingComment: null
};
